export const isValidUrl = (value: string): boolean => {
  const tldRegex = /\.[a-z]{2,}$/i;
  try {
    const url = new URL(value.startsWith('http') ? value : `https://${value}`);
    return tldRegex.test(url.hostname);
  } catch {
    return false;
  }
};
